import { graphql } from '../../generated';

export const SCHEDULE_EXPORT = graphql(`
  mutation ScheduleExport($type: String!, $arguments: JSON!) {
    scheduleExport(input: { type: $type, arguments: $arguments }) {
      export {
        id
        url
      }
    }
  }
`);

export const SCHEDULE_FILE_EXPORT = graphql(`
  mutation ScheduleFileExport($type: String!, $file: Upload!) {
    scheduleExport(input: { type: $type, file: $file }) {
      export {
        id
        url
        error
      }
    }
  }
`);

export const POLL_EXPORT = graphql(`
  query PollExport($id: ID!) {
    export(id: $id) {
      id
      url
      error
    }
  }
`);
